import { connect } from 'react-redux'
import { SigninFormComponent } from './SigninFormComponent'
import type { LoginForm } from 'shared/types'
import {
    clearSigninRedirect,
    resendMail,
    sendSigninForm
} from 'shared/store/signin'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import { push } from 'connected-react-router'

const mapStateToProps = (state: RootState) => state.signinPageState

const mapDispatchToProps = (d: Dispatch<any>) => ({
    signin: (form: LoginForm, fromEcommerce?: boolean) =>
        d(sendSigninForm(form, fromEcommerce)),
    resendMail: (queen: string) => d(resendMail(queen)),
    goToRedirectAndReset: (url: string, state?: any) => {
        d(clearSigninRedirect())
        d(push(url, state))
    }
})

const SigninForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(SigninFormComponent)

export { SigninForm }
